"use strict";

module.exports = require("../fine-uploader/fine-uploader");



//////////////////
// WEBPACK FOOTER
// ./~/fine-uploader/lib/traditional.js
// module id = 6
// module chunks = 1